import React from "react";

const SocialLinks = ({ className = "", position = "fixed" }) => {
  const socialLinks = [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/manas0609/",
      icon: "https://st4.depositphotos.com/1000417/41563/v/450/depositphotos_415634850-stock-illustration-linkedin-logo-vector-editorial-illustration.jpg",
      bgColor: "",
    },
    {
      name: "GitHub",
      url: "https://github.com/manasbhandari",
      icon: "https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_1280.png",
      bgColor: "",
      extraClasses: "border border-white",
    },
    {
      name: "Email",
      url: "mailto:manasbhandari06092002@gmail.com",
      icon: "https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/112-gmail_email_mail-512.png",
      bgColor: "",
      extraClasses: "0",
    },
  ];

  const baseClasses = `flex flex-col gap-1.5 sm:gap-2 z-10 ${className}`;
  const positionClasses =
    position === "fixed"
      ? "fixed bottom-4 right-3 sm:bottom-6 sm:right-4 md:bottom-8 md:right-6"
      : "";

  return (
    <div className={`${baseClasses} ${positionClasses}`}>
      {socialLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target={link.name === "Email" ? "_self" : "_blank"}
          rel={link.name === "Email" ? "" : "noopener noreferrer"}
          className={`${link.bgColor} rounded-lg h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 flex items-center justify-center hover:scale-105 transition-transform duration-200`}
          aria-label={`Visit ${link.name}`}
        >
          <img
            className={`w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 rounded object-cover ${
              link.extraClasses || ""
            }`}
            src={link.icon}
            alt={link.name}
          />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
